import axiosInstance from './axiosInstance';

const pdfApi = {
  // 上传PDF文件
  upload: async (file, subject, contentType) => {
    const formData = new FormData();
    formData.append('file', file);
    if (subject) {
      formData.append('subject', subject);
    }
    if (contentType) {
      formData.append('content_type', contentType);
    }
    const response = await axiosInstance.post('/pdf/upload', formData, {
      timeout: 300000, // 300秒(5分钟)超时
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // 获取文件列表
  getFiles: async () => {
    const response = await axiosInstance.get('/pdf/files');
    return response.data;
  },

  // 获取单个文件信息
  getFile: async (fileId) => {
    const response = await axiosInstance.get(`/pdf/files/${fileId}`);
    return response.data;
  },

  // 获取文件的签名URL
  getSignedUrl: async (fileId) => {
    const response = await axiosInstance.get(`/pdf/files/${fileId}/signed-url`);
    return response.data;
  },

  // 开始提取内容
  startExtract: async (fileId) => {
    const response = await axiosInstance.post(`/pdf/files/${fileId}/extract`);
    return response.data;
  },

  // 获取提取进度
  getProgress: async (fileId) => {
    const response = await axiosInstance.get(`/pdf/files/${fileId}/progress`);
    return response.data;
  },

  // 更新文件内容
  updateContent: async (fileId, content) => {
    const response = await axiosInstance.put(`/pdf/files/${fileId}/content`, { content });
    return response.data;
  },

  // 更新匹配状态
  updateMatchStatus: async (fileId, matchStatus) => {
    const response = await axiosInstance.put(`/pdf/files/${fileId}/match_status`, { match_status: matchStatus });
    return response.data;
  },

  // 删除文件
  deleteFile: async (fileId) => {
    const response = await axiosInstance.delete(`/pdf/files/${fileId}`);
    return response.data;
  },
  
  // 上传图片（用于编辑器直接上传）
  uploadImage: async (fileId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axiosInstance.post(`/pdf/files/${fileId}/upload-image`, formData, {
      timeout: 180000, // 180秒(3分钟)超时
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  
  // 从URL获取图片（用于编辑器粘贴外部图片）
  fetchImage: async (fileId, imageUrl) => {
    const response = await axiosInstance.post(`/pdf/files/${fileId}/fetch-image`, { url: imageUrl }, {
      timeout: 180000 // 180秒(3分钟)超时
    });
    return response.data;
  }
};

export { pdfApi }; 